import { retrieveVehicleExamples } from '../helpers/helperVehicleExamples';
import HelperEnv from '../helpers/HelperEnv';
import { fetchSimulationVehicleDetailsIfNeeded } from './actionsApiSimulation';
import { setLoadVehicle } from './actionsApi';
/*
 * action types
 */

export const SETTING_SET_DEVELOPPER_VIEW = 'SETTING_SET_DEVELOPPER_VIEW';
export const SETTING_SET_VIEW_FINANCE_FILE = 'SETTING_SET_VIEW_FINANCE_FILE';
export const SETTING_SET_PERIMETER_FILTER = 'SETTING_SET_PERIMETER_FILTER';
export const SETTING_SET_WIDGET_TYPE = 'SETTING_SET_WIDGET_TYPE';
export const SETTING_SET_USE_AUTHENTICATION_FOR_PUBLIC = 'SETTING_SET_USE_AUTHENTICATION_FOR_PUBLIC';
export const SETTING_SET_NETWORK_ZONE = 'SETTING_SET_NETWORK_ZONE';
export const SETTING_SET_FINFILE_RESOURCE = 'SETTING_SET_FINFILE_RESOURCE';
export const SETTING_SET_VIEW_TEST_CALCULATOR = 'SETTING_SET_VIEW_TEST_CALCULATOR';
export const SETTING_SET_AMOUNT_NATURE = 'SETTING_SET_AMOUNT_NATURE';
export const SETTING_SET_VEH_DESC_TYPE = 'SETTING_SET_VEH_DESC_TYPE';
export const SETTING_SET_PROCESS = 'SETTING_SET_PROCESS';
export const SETTING_SET_FINANCEFILE_PROPS = 'SETTING_SET_FINANCEFILE_PROPS';
export const SETTING_SET_ZINDEX = 'SETTING_SET_ZINDEX';
export const CONTEXT_SET_COUNTRY = 'CONTEXT_SET_COUNTRY';
export const CONTEXT_SET_CONTEXT = 'CONTEXT_SET_CONTEXT';
export const CONTEXT_SET_CUSTOMER = 'CONTEXT_SET_CUSTOMER';
export const CONTEXT_SET_CUSTOMERTYPE = 'CONTEXT_SET_CUSTOMERTYPE';
export const VEHICLE_SET_VEHICLE = 'VEHICLE_SET_VEHICLE';
export const VEHICLES_SET_VEHICLES_CONFIG = 'VEHICLES_SET_VEHICLES_CONFIG';
export const VEHICLES_SET_VEHICLES_STOCK = 'VEHICLES_SET_VEHICLES_STOCK';
export const PARAMETERS_SET_PARAMETERS = 'PARAMETERS_SET_PARAMETERS';
export const PARAMETERS_SET_WIDPARAMETERS = 'PARAMETERS_SET_WIDPARAMETERS';
export const SET_PART_EXCHANGE = 'SET_PART_EXCHANGE';
export const AVAILABLE_OPTIONS_SET_OPTIONS = 'AVAILABLE_OPTIONS_SET_OPTIONS';
export const AVAILABLE_ACCESSORIES_SET_ACCESSORIES = 'AVAILABLE_ACCESSORIES_SET_ACCESSORIES';
export const WIDGET_OPEN = 'WIDGET_OPEN';
export const RELOAD_WIDGET_SFS = 'RELOAD_WIDGET_SFS';
export const RESET_POSTS = 'RESET_POSTS';
export const REINIT_POSTS_UNAUTHORISED = 'REINIT_POSTS_UNAUTHORISED';
export const SETTING_SET_LANGUAGE = 'SETTING_SET_LANGUAGE';
export const SETTING_SET_VEHICLE_EXAMPLES = 'SETTING_SET_VEHICLE_EXAMPLES';

/*
 * action creators
 */

export function openWidget(isOpen) {
    return {
        type: WIDGET_OPEN, payload: { isOpen }
    }
}
export function setDevelopperView(isDevelopperView) {
    return { type: SETTING_SET_DEVELOPPER_VIEW, payload: { isDevelopperView } }
}
export function setViewFinanceFile(isFinanceFile) {
    return { type: SETTING_SET_VIEW_FINANCE_FILE, payload: { isFinanceFile } }
}
export function setPerimeterFilter(perimeterFilter, vehDescType) {
    return { type: SETTING_SET_PERIMETER_FILTER, payload: { perimeterFilter, vehDescType } }
}
export function setWidgetType(widgetType) {
    return { type: SETTING_SET_WIDGET_TYPE, payload: { widgetType } }
}
export function setNetworkZone(networkZone) {
    return { type: SETTING_SET_NETWORK_ZONE, payload: { networkZone } }
}
export function setFinanceFileResource(finfileResource) {
    return { type: SETTING_SET_FINFILE_RESOURCE, payload: { finfileResource } }
}
export function setViewTestCalculator(isTestCalculator) {
    return { type: SETTING_SET_VIEW_TEST_CALCULATOR, payload: { isTestCalculator } }
}
export function setAmountNature(amountNature) {
    return { type: SETTING_SET_AMOUNT_NATURE, payload: { amountNature } }
}
export function setVehicleDescriptionType(vehDescType, perimeterFilter) {
    return { type: SETTING_SET_VEH_DESC_TYPE, payload: { vehDescType, perimeterFilter } }
}
export function setProcess(process) {
    return { type: SETTING_SET_PROCESS, payload: { process } }
}
export function setFinanceFileProps(username, password, isFinanceFile) {
    return { type: SETTING_SET_FINANCEFILE_PROPS, payload: { financeFileProps: { username, password }, isFinanceFile } }
}
export function setContextCountry(context, perimeterFilter, vehDescType) {
    return { type: CONTEXT_SET_COUNTRY, payload: { context, perimeterFilter, vehDescType } }
}
export function setContextCustomerType(context) {
    return { type: CONTEXT_SET_CUSTOMERTYPE, payload: { context } }
}
export function setContext(context, perimeterFilter, vehDescType) {
    return { type: CONTEXT_SET_CONTEXT, payload: { context, perimeterFilter, vehDescType } }
}
export function setCustomer(customer) {
    return { type: CONTEXT_SET_CUSTOMER, payload: { customer } }
}
export function setVehicle(vehicle) {
    return { type: VEHICLE_SET_VEHICLE, payload: { vehicle } }
}
export function setAvailableOptions(options) {
    return { type: AVAILABLE_OPTIONS_SET_OPTIONS, payload: { options } }
}
export function setAvailableaccessories(accessories) {
    return { type: AVAILABLE_ACCESSORIES_SET_ACCESSORIES, payload: { accessories } }
}
export function setVehiclesConfig(vehicles) {
    return { type: VEHICLES_SET_VEHICLES_CONFIG, payload: { vehicles } }
}
export function setVehiclesStock(vehicles) {
    return { type: VEHICLES_SET_VEHICLES_STOCK, payload: { vehicles } }
}
export function setFinParameters(parameters) {
    return { type: PARAMETERS_SET_PARAMETERS, payload: { parameters } }
}
export function setPartExchange(partExchange) {
    return { type: SET_PART_EXCHANGE, payload: { partExchange } }
}
export function setWidgetParameters(widgetParameters) {
    return { type: PARAMETERS_SET_WIDPARAMETERS, payload: { widgetParameters } }
}
export function setZIndex(zindex) {
    return { type: SETTING_SET_ZINDEX, payload: { zindex } }
}
export function reloadWidgetSFS() {
    return { type: RELOAD_WIDGET_SFS }
}
export function resetPosts() {
    return { type: RESET_POSTS }
}
export function reInitPostsUnauthorised() {
    return { type: REINIT_POSTS_UNAUTHORISED }
}
export function setSettingLanguage(language, contextLanguage) {
    return { type: SETTING_SET_LANGUAGE, payload: { language, contextLanguage } }
}
export function setVehicleExamples(context, settings, state, dispatch) {
    const vehicleExamples = retrieveVehicleExamples(context, settings);
    const vehicles = vehicleExamples.vehicles != null ? vehicleExamples.vehicles : [];
    if (state && state.loading && state.loading.vehicleExamplesLoadedOnce === false) {
        const firstVehicle = vehicles.length > 0 ? vehicles[0] : null;
        if (firstVehicle !== null && HelperEnv.isEnabledTestVehicles(state.env)) {
            dispatch(setVehicle(firstVehicle));
            dispatch(setLoadVehicle({ vehicleExamplesLoadedOnce: false }));
            fetchSimulationVehicleDetailsIfNeeded(state, dispatch, {vehicle:firstVehicle}, null, false, false);
        }
    }
    return { type: SETTING_SET_VEHICLE_EXAMPLES, payload: { vehicleExamples: vehicles } }
}
